"use client";

import { useEffect } from "react";
import { CmsBrand } from "./CmsBrand";

export interface CmsErrorProps {
  error: Error & { digest?: string };
  retry: () => void;
}

/** Independent of layouts, translations and styles so root failures stay readable. */
export function CmsErrorPage({ error, retry }: CmsErrorProps) {
  useEffect(() => { console.error("De CMS-pagina kon niet worden geladen", error); }, [error]);
  return <main lang="nl" style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, background: "#f3f5f7", color: "#243342", fontFamily: "Arial, sans-serif", textAlign: "center" }}>
    <section style={{ maxWidth: 480, display: "grid", justifyItems: "center", gap: 20 }}>
      <CmsBrand width={160} />
      <h1 style={{ margin: 0, fontSize: 28 }}>Deze pagina kon niet worden geladen</h1>
      <p style={{ margin: 0, lineHeight: 1.6 }}>Probeer het opnieuw. Blijft de melding staan, neem dan contact op met de beheerder.</p>
      {error.digest && <p style={{ fontSize: 12 }}>Foutreferentie: {error.digest}</p>}
      <button type="button" onClick={retry} style={{ padding: "12px 20px", background: "#4759e4", color: "#fff", border: 0, borderRadius: 8, cursor: "pointer", font: "inherit" }}>Opnieuw proberen</button>
      <a href="/admin" style={{ color: "#243342" }}>Naar het CMS</a>
    </section>
  </main>;
}
